import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserSessionService } from '../../app-user-session.service';
import { AuthService, LoginViewModel } from '../../shared';
import { ToastService } from '../blocks';

@Component({
  selector: 'app-user-signature',
  templateUrl: './user-signature.component.html',
  styleUrls: ['./user-signature.component.css']
})
export class UserSignatureComponent implements OnInit {
  loginModel: LoginViewModel = <LoginViewModel>{};
  public errorMsg = '';
  authResult: boolean = true;
  displayFlag: any;
  showMessage: boolean = true;
  constructor(public translate: TranslateService,
    private _toastService: ToastService,
    private _authService: AuthService


  ) { }

  ngOnInit() {
    this.getUserData();
  }
  currentUserData: any;
  getUserData() {
    this.currentUserData = JSON.parse(sessionStorage.getItem('currentUser'));
    this.loginModel.userName = this.currentUserData.userName;
    console.log("CurrentUser is :" + this.currentUserData)

  }

  authMsg: any;
  confirmUserSignature() {
    if ((this.loginModel.userName == undefined || this.loginModel.userName == null || !this.loginModel.userName.replace(/\s/g, '').length) ||
      (this.loginModel.password == undefined || this.loginModel.password == null || !this.loginModel.password.replace(/\s/g, '').length)) {
      this._toastService.activateMsg('WARNINGUSERNAMEPASSWORD');
      return;
    }
    this._authService.confirmUserSignature(this.loginModel).subscribe(
      u => {
        this.authResult = u;
      },
      error => { },
      () => {
        this.errorMsg = '';
        let loginErrors = JSON.parse(sessionStorage.getItem('loginErrors'));
        if (this.authResult) {
          this.showMessage = true;
          this._toastService.toastMsg('تم تأكيد الاستلام', 'تأكيد', 'Success')
        }
        else {
          // this.errorMsg = "اسم المستخدم او كلمة المرور غير صحيح";
          if (loginErrors.messageCode == -100) {
            this.errorMsg = "اسم المستخدم غير صحيح";
          } else if (loginErrors.messageCode == -101) {
            this.errorMsg = "كلمة المرور غير صحيحة";
          } else if (loginErrors.messageCode == -102) {
            this.errorMsg = "هذا المستخدم غير فعال";
          }
          this.showMessage = false;
        }
      });
  }

}
